import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type filterSchedulesServicePayload = {
  dtStart: string
  dtEnd: string
}

export async function filterSchedulesService(
  payload: filterSchedulesServicePayload,
) {
  const { data } = await api.get<ResponseAPI>(
    `agendamento/${payload.dtStart}/${payload.dtEnd}`,
  )
  return data
}
